const STORAGE_KEY = "sp_cookie_consent";
// Fired whenever the user makes a fresh consent decision (not on every page
// load — only when saveCookieConsent actually runs, i.e. the banner was
// shown and answered). AppContent listens for this to re-run its single
// page-view tracking effect, so the page the user is already on gets
// tracked immediately on first-time consent instead of only on next
// navigation. Kept generic (not GA4-specific) since PostHog init already
// reacts to the same moment via CookieConsent's direct initPostHog() call.
export const COOKIE_CONSENT_CHANGED_EVENT = "sp-cookie-consent-changed";

export const getCookieConsent = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const saveCookieConsent = (analytics) => {
  const consent = { necessary: true, analytics: !!analytics, decidedAt: new Date().toISOString() };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
  } catch {
    // localStorage unavailable (private browsing etc.) — consent just won't persist across visits.
  }
  window.dispatchEvent(new CustomEvent(COOKIE_CONSENT_CHANGED_EVENT, { detail: consent }));
  return consent;
};

export const hasAnalyticsConsent = () => !!getCookieConsent()?.analytics;
